import { LegalDocumentPage } from "components/LegalDocumentPage";
import {
  investmentRisksMeta,
  investmentRisksIntro,
  investmentRisksSections,
} from "content/investmentRisksContent";

export default function InvestmentRisksPage() {
  return (
    <LegalDocumentPage
      meta={investmentRisksMeta}
      intro={investmentRisksIntro}
      sections={investmentRisksSections}
      helmetDescription="Investment risks associated with equity crowdfunding and early-stage companies on Fortify."
    />
  );
}
